import { BFFAgent } from '../../../common/BFFAgent'
import {
  PRESUPUESTADOR_SET_PATENTE,
  PRESUPUESTADOR_SET_PATENTE_INVALID,
} from './constants';
import validatePatente from '../../common/backend/validatePatente'
import { PERITAJE_STATUS } from '../../../common/BFF/BFF_peritador/constants'
import { PATENTE_LOCKED } from 'presupuestador/lib/constants';

export function setPatente(patente, quotation_id) {
  return async (dispatch, getState) => {
    // Valido el formato de la patente
    const valid = validatePatente(patente)
    const { presupuestador } = getState()
    if(valid){
      // Controlo que la patente no exista
      const existePatente = presupuestador.entregaUsados.some((item) => item.patente.toUpperCase() === patente.toUpperCase())
      if(existePatente){
        dispatch({
          type: PRESUPUESTADOR_SET_PATENTE_INVALID,
          data: {
            patente,
            quotation_id,
            error: 'La patente ya existe',
            patenteCodeError: {
              code: 'invalid',
              message: 'La patente ya existe',
            }
          }
        })
      } else {
        const res = await BFFAgent.Peritador.getLockedPatent(patente)
        if (!res.locked) {
          const { peritaje, peritajeQuote } = await BFFAgent.Peritador.getPeritaje(patente, true, PERITAJE_STATUS.PERITAJE_FINALIZADO)
          if(peritajeQuote){
            dispatch({
              type: PRESUPUESTADOR_SET_PATENTE,
              data: {
                patente: peritaje.servicePatent,
                quotation_id,
                peritaje,
                peritajeQuote: peritajeQuote
              }
            })
          }
          dispatch({
            type: PRESUPUESTADOR_SET_PATENTE,
            data: {
              patente,
              quotation_id,
              peritajePendiente: peritaje,
            }
          })
        } else {
          dispatch({
            type: PRESUPUESTADOR_SET_PATENTE_INVALID,
            data: {
              patente,
              quotation_id,
              error: PATENTE_LOCKED,
              patenteCodeError: {
                code: 'patenteBloqueada',
                message: PATENTE_LOCKED,
              }
            }
          })
        }
      }
    } else {
      dispatch({
        type: PRESUPUESTADOR_SET_PATENTE_INVALID,
        data: {
          patente,
          quotation_id,
          error: 'La patente es inválida',
          patenteCodeError: {
            code: 'invalid',
            message: 'La patente es inválida',
          }
        }
      })
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_SET_PATENTE:
      return {
        ...state,
        entregaUsados: state.entregaUsados.map(usado => {
          if(action.data.quotation_id === usado.quotation_id){
            if(action.data.peritaje){
              if(!action.data.peritajeQuote){
                return {
                  ...usado,
                  pending: false,
                  error: null,
                  peritado: action.data.peritaje.statusId, 
                  requestsId: action.data.peritaje.id,
                }
              }
              return {
                oldValue: 0,
                final_take_price: action.data.peritajeQuote.appraisal,
                quotation_id: action.data.peritajeQuote.requestsId,
                year: action.data.peritajeQuote.verification?.original_vehicle?.year?.label || action.data.peritajeQuote.verification.vehicle.year.label,
                brand: action.data.peritajeQuote.verification.vehicle.brand.label,
                model: action.data.peritajeQuote.verification.vehicle.model.label,
                version: action.data.peritajeQuote.verification?.original_vehicle?.version?.label || action.data.peritajeQuote.verification.vehicle.version.label,
                versionId: action.data.peritajeQuote.verification?.original_vehicle?.version?.value || action.data.peritajeQuote.verification.vehicle.version.value,
                km: action.data.peritajeQuote.verification.original_kilometraje || action.data.peritajeQuote.verification.kilometraje,
                appraisal: action.data.peritajeQuote.appraisal,
                peritado: action.data.peritajeQuote.verification.statusId,
                verificationDate: action.data.peritajeQuote.verification.verificationDate,
                patente: action.data.patente,
                pending: false,
                error: null,
                valid: true,
                original_price: action.data.peritajeQuote.appraisal,
                use_take_improvement: 0,
                take_improvement_amount: 0,
                version_id:action.data.peritajeQuote.verification.vehicle.version.value,
                license_plate: action.data.peritajeQuote.patente,
                requestsId: action.data.peritajeQuote.requestsId,
                verification: action.data.peritajeQuote.verification,
                appraisal_approved: action.data.peritajeQuote.appraisal_approved,
              }
            }
            return {
              ...usado,
              agregarPatente: false,
              patente: action.data.patente,
              peritado: action.data?.peritajePendiente?.peritado,
              errorPeritaje: '',
              patenteCodeError: action.data.patenteCodeError,
              requestsId: action.data?.peritajePendiente?.id
            }
          } else {
            return usado
          }
        })
      };
    case PRESUPUESTADOR_SET_PATENTE_INVALID:
      return {
        ...state,
        entregaUsados: state.entregaUsados.map(usado=>{
          if(action.data.quotation_id === usado.quotation_id){
            return {
              ...usado,
              agregarPatente: true,
              patente: usado.patente || '',
              errorSetPatente: action.data.error,
              errorPeritaje: '',
              patenteCodeError: action.data.patenteCodeError
            }
          } else {
            return usado
          }
        })
      };
    default:
      return state;
  }
}
